// Subscription tier configuration
// Maps Stripe product IDs to tier information

export type SubscriptionTier = 'individual' | 'agency' | null;

export interface TierConfig {
  name: string;
  price: number;
  priceId: string;
  productId: string;
  description: string;
  features: string[];
  hasTeamFeatures: boolean;
}

export const SUBSCRIPTION_TIERS: Record<Exclude<SubscriptionTier, null>, TierConfig> = {
  individual: {
    name: 'Individual',
    price: 197,
    priceId: 'price_1SoYis95JT3WBATlVFrL9qVV',
    productId: 'prod_Tm6wn47Ib2HxdD',
    description: 'Perfect for individual producers looking to level up their practice',
    features: [
      'Full access to all strategic planning calculators',
      'ICHRA Calculator & Business Case Builder',
      'Cross-Sell & Broker ROI Calculators',
      'CPA & Agent Recruitment Calculators',
      'ACA Affordability Tools',
      'AI-powered assistant',
      'Future calculator updates included',
    ],
    hasTeamFeatures: false,
  },
  agency: {
    name: 'Agency',
    price: 697,
    priceId: 'price_1SoYja95JT3WBATl8ZHNLSHS',
    productId: 'prod_Tm6xNozybGqUUb',
    description: 'Best for agency owners and managers with teams.',
    features: [
      'Everything in Individual, plus:',
      'Organization & team management',
      'Manager & employee role hierarchy',
      'Team invite codes & email invites',
      'Shared calculator access for team',
    ],
    hasTeamFeatures: true,
  },
};

// Helper to get tier from product ID
export function getTierFromProductId(productId: string | null): SubscriptionTier {
  if (!productId) return null;
  
  // Admin full access - treat as agency tier (highest tier)
  if (productId === 'admin_full_access') {
    return 'agency';
  }
  
  for (const [tier, config] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (config.productId === productId) {
      return tier as SubscriptionTier;
    }
  }
  
  // Legacy support for old product
  if (productId === 'prod_Tm4XDUKabmVHM7') {
    return 'individual'; // Treat old $397 subscribers as individual
  }
  
  return null;
}

// Helper to check if user has team features
export function hasTeamAccess(productId: string | null): boolean {
  // Admin full access - has all features
  if (productId === 'admin_full_access') {
    return true;
  }
  
  const tier = getTierFromProductId(productId);
  if (!tier) return false;
  return SUBSCRIPTION_TIERS[tier].hasTeamFeatures;
}
